import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import React from 'react';
// import enUS from '@arco-design/web-react/es/locale/en-US';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
export const ArcoProvider = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: zhCN,
    componentConfig: {
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, children);
};